
// import router from "../router/index";
// import store from "../store";
import BaseApi from "./BaseApi";

export default class RolService extends BaseApi {


    constructor(){
        super();
    }

    async getSelect()
    {
        return this.http.get(`${this.baseUrl}/getRoles`)
        .catch(this.handleErrorResponse);
    }


    async list()
    {
        return this.http.get(`${this.baseUrl}/roles`)
        .catch(this.handleErrorResponse);
    }

    async get(slug)
    {
        return this.http.get(`${this.baseUrl}/roles/${slug}/edit`)
        .catch(this.handleErrorResponse);
    }


    async store(data)
    {
        return this.http.post(`${this.baseUrl}/roles/store`, data)
        .catch(this.handleErrorResponse);
    }

    async update(data, slug)
    {
        return this.http.put(`${this.baseUrl}/roles/${slug}/update`, data)
        .catch(this.handleErrorResponse);
    }
   


    async delete(slug)
    {
        return this.http.delete(`${this.baseUrl}/roles/${slug}/delete`)
        .catch(this.handleErrorResponse);
    }
}